<template>

    <div 
    
    class="h-20 w-full top-0 fixed bg-gray-200 bg-opacity-0 transition-all duration-300 flex z-30"

    :class="{ 
        'bg-opacity-75': !emptyHeader,
        'bg-opacity-100': solidHeader || search || !banner
    }"

    >
    
        <div class="w-40 min-w-40 h-full" >

            <img draggable="false" class="w-40 h-full" src="/images/logo.png" alt="logo" >

        </div>

        <div class="w-full max-w-screen-xl m-auto px-6 grid grid-cols-6 gap-6 items-center" >

            <router-link class="btn" to="/appointments" >Appointments</router-link>

            <router-link class="btn" to="/invoices" >Invoices</router-link>

            <searchbar class="col-span-2" />

            <c-select 
            
            prefix="By: "
            class="col-span-2"
            placeholder="Select Search Option"

            :color="true"
            :naked="true"
            :preselected="true"
            :list="searchOptions"
            
            v-model="searchOption"
            
            />

        </div>

        <div class="w-40 flex items-center" >

            <user-card />

        </div>

        <transition name="fade-in" @after-enter="drop = true" @leave="drop = false" >

            <div class="searchbox" v-if="search" @click.stop="search = ''" >

                <div class="searchbox-drop" :class="{ 'searchbox-drop-open': drop }" >


                </div>

            </div>

        </transition>

    </div>
    
</template>

<script>

    import { useStore } from 'vuex'
    import { ref, computed, onMounted, onBeforeUnmount, watch } from 'vue'

    import cSelect from './select'
    import userCard from './usercard'
    import searchbar from './searchbar'

    export default {
    
        name: 'Header',

        components: { searchbar, cSelect, userCard },

        setup( props, context ) {

            const drop = ref(false)
            const store = useStore()
            const banner = computed(() => store.state.banner )
            const emptyHeader = computed(() => store.state.properties.appScrollTop < 80 )
            const solidHeader = computed(() => store.state.properties.appScrollTop > 400 - 80 )

            // Search

            const search = computed({
                get: () => store.state.search,
                set: val => store.commit( 'setSearch', val )
            })

            const searchOption = ref([])

            const searchOptions = computed(() => store.state.searchOptions )

            const setSearchOption = (e) => { searchOption.value = e }

            const preventScroll = computed({
                get: () => store.state.properties.preventScroll,
                set: val => store.commit( 'setPreventScroll', val )
            })

            watch(search, () => {

                if ( search.value ) preventScroll.value = true
                else preventScroll.value = false

            })

            return {
                drop,
                search,
                banner,
                searchOption,
                searchOptions,
                setSearchOption,
                emptyHeader,
                solidHeader
            }

        }

    }

</script>

<style scoped>

    /* Applied Utils */

    .router-link-active {
        @apply 
            text-white 
            bg-ch-blue 
            border-0
    }

    .searchbox {

        backdrop-filter: blur(4px);

        @apply 
            w-full 
            h-screen 
            absolute
            top-80 
            left-0 
            bg-ch-blue 
            bg-opacity-75

    }

    .searchbox-drop {
        background-image: url("/images/loader.svg");
        @apply 
            h-0 
            w-9/12 
            absolute 
            top-0 
            left-1/2 
            transition-height 
            duration-300 
            transform 
            -translate-x-1/2 
            rounded-cs-md 
            rounded-t-none 
            bg-gray-100
            bg-no-repeat
            bg-center
    }

    .searchbox-drop-open {
        @apply h-98
    }

</style>